module.exports = __webpack_public_path__ + "img/cases-brand-suning-lazyload-04.6ce8a648.jpg";